















import Vue from 'vue'
import { mapGetters } from 'vuex'

export default Vue.extend({
  name: 'Ban',
  data() {
    return {
      message: ''
    }
  },
  computed: {
    ...mapGetters('Auth', ['isBan'])
  },
  created() {
    if (!this.isBan) {
      this.$router.replace('/login')
      return
    }

    this.message =
      '規約違反を確認したため、アカウントを停止いたしました。\n' +
      'このアカウントデータではもうご利用いただけません。\n'
  },
  methods: {
    async ask() {
      location.href = await this.$_mailTo
    }
  }
})
